import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from './Icons';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 10 años en la iglesia y nunca había sentido a Dios como lo siento ahora. El Método de los 3 Filtros me enseñó a distinguir Su voz. Por primera vez, tomé una decisión difícil sabiendo que no caminaba solo. Mi ansiedad desapareció en la segunda semana.',
    name: 'Elena R.',
    location: 'Madrid',
    result: 'Paz mental y claridad en 14 días'
  }, {
    quote: "Pensé que esto era para 'super-cristianos' con toda la vida espiritual en orden. Yo soy escéptico por naturaleza. Pero Intimidad Radical me dio herramientas prácticas, no rollos religiosos. Ahora mi tiempo de oración es el momento que más espero del día.",
    name: 'Mateo V.',
    location: 'México DF',
    result: 'Conexión auténtica tras años de apatía'
  }, {
    quote: 'Lo que más me impactó fue entender que la Biblia no es un manual de instrucciones sino una carta de amor. Llevo años leyéndola de la manera equivocada. Desde que aplico la lectura contemplativa, cada pasaje es un encuentro, no un estudio.',
    name: 'Claudia M.',
    location: 'Miami',
    result: 'La Biblia cobró vida después de años de sequía'
  }, {
    quote: "Había acumulado tanto daño religioso que casi no podía orar sin sentir culpa. El capítulo sobre 'Dios no te avergüenza con el pasado perdonado' me liberó de algo que cargaba hace 8 años. Literalmente lloré leyéndolo.",
    name: 'Roberto A.',
    location: 'Buenos Aires',
    result: 'Liberación de culpa religiosa profunda'
  }];
  return <section className="bg-dark-texture text-cream py-24 px-4" data-id="element-305">
      <div className="max-w-6xl mx-auto" data-id="element-306">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-307">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-308">
            Historias de Transformación
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-309" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-310">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-light p-8 rounded-xl border border-white/10 relative" data-id="element-311">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-white/5" data-id="element-312" />
              <div className="flex gap-1 mb-6" data-id="element-313">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-314" />)}
              </div>
              <p className="text-lg font-serif italic mb-8 text-cream/90 relative z-10" data-id="element-315">
                "{t.quote}"
              </p>
              <div className="border-t border-white/10 pt-6" data-id="element-316">
                <p className="font-bold text-gold text-lg" data-id="element-317">{t.name}</p>
                <p className="text-sm text-cream/50 mb-3" data-id="element-318">{t.location}</p>
                <div className="inline-block bg-olive/30 text-olive-light px-3 py-1 rounded-full text-xs font-bold tracking-wide" data-id="element-319">
                  Resultado: {t.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}